import MemberEditApi from '@api/MemberEditApi'

window.api = new MemberEditApi()
